import angular from 'angular';

// TODO move to common utils
function parseQuery(qstr) {
  const query = {};
  if (qstr.length < 2) {
    return query;
  }
  const params = qstr.substr(1).split('&');
  for (let i = 0; i < params.length; i++) {
    const parts = params[i].split('=');
    const key = parts.shift();
    query[decodeURIComponent(key)] = decodeURIComponent(parts.join('=') || '');
  }
  return query;
}

// map to hold dependencies and expose them outside of the constructor initialization
const deps = {};

class AuthService {
  /* ----------------------------------- *\
   * Constructor
  \* ----------------------------------- */
  constructor($http, $q, $window, config, localService, authHelper, storageKeys) {
    deps.$http = $http;
    deps.$q = $q;
    deps.$window = $window;
    deps.config = config;
    deps.localService = localService;
    deps.authHelper = authHelper;
    deps.storageKeys = storageKeys;
  }

  getToken() {
    const localService = deps.localService;
    return localService.get('jwt_token');
  }

  isAuthorized() {
    const jwt = this.getToken();
    return !!jwt && !deps.authHelper.isTokenExpired(jwt);
  }

  authorize() {
    const config = deps.config;
    const localService = deps.localService;
    const $http = deps.$http;
    const $q = deps.$q;
    const $window = deps.$window;
    const params = parseQuery($window.location.search);
    let authToken = params.auth_token;
    const mockData = params.mockdata;
    // fetch authToken from url and store for future use
    if (authToken) {
      localService.set(deps.storageKeys.authToken, authToken);
    } else {
      authToken = localService.get(deps.storageKeys.authToken);
    }

    // if there is a mock data flag in the URL we set it in storage to mock user data
    // after authorizing for testing purposes. This will most of the time contain
    // an IP address which is used by the server to detect the user profile and authorize the request
    // for testers outside of a Altice network, we need to use a mock IP to test the geolocation.
    if (mockData) {
      localService.set(deps.storageKeys.mockData, mockData);
    }

    const data = {
      authToken
    };

    if (this.isAuthorized()) {
      return $q.resolve(this.getToken());
    }
    if (!data.authToken) {
      return $q.reject('Auth token missing');
    }
    // return a promise that returns the jwt token
    return $http({
      url: config.relBaseUrlAuthAPi + '/authorize',
      // This will not send the JWT for this call
      skipAuthorization: true,
      method: 'POST',
      data
    }).then((response) => {
      localService.set('jwt_token', response.data);
      return response.data;
    });
  }

  unauthorize() {
    // The backend doesn't care about logouts, delete the token and you're good to go.
    const localService = deps.localService;
    localService.remove('jwt_token');
  }

  static factory($http, $q, $window, config, localService, authHelper, storageKeys) {
    return new AuthService($http, $q, $window, config, localService, authHelper, storageKeys);
  }
}

AuthService.factory.$inject = ['$http', '$q', '$window', 'config', 'localService', 'authHelper', 'storageKeys'];

const module = angular
  .module('auth', ['auth.authHelper', 'auth.authInterceptor', 'localService', 'config', 'constants'])
  .factory('authService', AuthService.factory);

export default module;



/** WEBPACK FOOTER **
 ** ./client/app/services/auth/auth.js
 **/